import request from '@/router/axios'

export const getList = (current, size, params) => request({
  url: '/api/mcc-worker/dwellroom/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getBlockTreeList = (current, size, params) => request({
  url: '/api/mcc-worker/dwellplot/plot',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getRoomWorkerList = (current, size, params) => request({
  url: '/api/mcc-worker/dwellroomref/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const add = params => request({
  url: '/api/mcc-worker/dwellroom/save',
  method: 'post',
  data: params,
})

export const remove = ids => request({
  url: '/api/mcc-worker/dwellroom/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const update = params => request({
  url: '/api/mcc-worker/dwellroom/update',
  method: 'post',
  data: params,
})

export const getNoRoomList = (current, size, params) => request({
  url: '/api/mcc-worker/dwellroomref/noUnitWorker',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const addRoomWorkers = params => request({
  url: '/api/mcc-worker/dwellroomref/saveWorker',
  method: 'post',
  data: params,
})

export const downLoadUnitExcel = () => request({
  url: '/api/mcc-worker/dwellroom/unitExcel',
  method: 'get',
  responseType: 'blob',
})

export const uploadUnitExcel = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/dwellroom/unitExcel2',
    method: 'post',
    data: formData,
  })
}

export default {
  getList,
}
